'use client'

import React from 'react'
import { Label } from '@/components/ui/label'

interface CampsFilterProps {
  onlyWithRegistrations: boolean
  onlyFutureCamps: boolean
  onOnlyWithRegistrationsChange: (value: boolean) => void
  onOnlyFutureCampsChange: (value: boolean) => void
}

interface SwitchProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  id: string
}

const Switch: React.FC<SwitchProps> = ({ checked, onCheckedChange, id }) => (
  <div
    role="switch"
    aria-checked={checked}
    id={id}
    onClick={() => onCheckedChange(!checked)}
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault()
        onCheckedChange(!checked)
      }
    }}
    className={`
      relative inline-flex h-6 w-11 items-center rounded-full cursor-pointer
      transition-colors duration-200 ease-in-out p-0.5 border-0 outline-none shadow-none
      focus:outline-none focus:shadow-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-0
      ${checked ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-200 hover:bg-gray-300'}
    `}
  >
    <span
      className={`
        pointer-events-none block h-5 w-5 rounded-full bg-white border-0 outline-none shadow-none
        transition-transform duration-200 ease-in-out ${checked ? 'translate-x-5' : 'translate-x-0'}
      `}
    />
  </div>
)

const CampsFilter: React.FC<CampsFilterProps> = ({
  onlyWithRegistrations,
  onlyFutureCamps,
  onOnlyWithRegistrationsChange,
  onOnlyFutureCampsChange,
}) => {
  return (
    <div className="flex items-center gap-8">
      <div className="flex items-center space-x-3">
        <Switch
          id="only-with-registrations"
          checked={onlyWithRegistrations}
          onCheckedChange={onOnlyWithRegistrationsChange}
        />
        <Label
          htmlFor="only-with-registrations"
          className="text-sm font-medium text-gray-700 cursor-pointer"
        >
          Nur Camps mit Anmeldungen
        </Label>
      </div>

      <div className="flex items-center space-x-3">
        <Switch
          id="only-future-camps"
          checked={onlyFutureCamps}
          onCheckedChange={onOnlyFutureCampsChange}
        />
        <Label
          htmlFor="only-future-camps"
          className="text-sm font-medium text-gray-700 cursor-pointer"
        >
          Nur zukünftige Camps
        </Label>
      </div>
    </div>
  )
}

export default CampsFilter
